import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { StoreStatement } from '../models/profile.model';

@Injectable()
export class DashboardService {
    constructor(private http: HttpClient) {
    }

    getAdminLeads(): any {
        return this.http.get(Configuration.apiUrl + 'api/lead/getleads')
    }

    getAdminLeadNotAccounts(): any {
        return this.http.get(Configuration.apiUrl + 'api/lead/getLeadsnotAccount')
    }

    deleteLead(email): any {
        return this.http.get(Configuration.apiUrl + 'api/lead/deletelead?email=' + email)
    }

    getCabiancaChart(storeName, month, year): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/GetOverview/?month=' + month + '&year=' + year + '&storeName=' + storeName + '&initialDate=&lastDate=')
    }

    getAdminCabiancaChart(month, year): any {
        console.log(Configuration.apiUrl + 'Api/Dashboard/GetAdminOverview/?month=' + month + '&year=' + year + '&initialDate=&lastDate=');
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/GetAdminOverview/?month=' + month + '&year=' + year + '&initialDate=&lastDate=')
    }

    getCabiancaChartByRangeDate(storeName, initialDate, lastDate): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/GetOverview/?initialDate=' + initialDate + '&lastDate=' + lastDate + '&storeName=' + storeName + '&month=0&year=0')
    }

    getAdminStore(id): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminStoreById?id=' + id)
    }

    getAdminStores(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminStores')
    }

    getAdminCachedStores(): any {
        if (Configuration.apiUrl.indexOf("fernandott") >= 0)
            return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminTakeBasicStores?seoUrl=codebrincosmasculinos')
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminCachedBasicStores')
    }

    getByTag(tag: string): any {
            return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminGetByTag?tag=' + tag)
    }

    getCachedInTheGameStores(): any {
        if (Configuration.apiUrl.indexOf("fernandott") >= 0)
            return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminCachedInTheGameStores?seoUrl=codebrincosmasculinos')
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminCachedInTheGameStores')
    }

    getAllStoresInHistory(): any{
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/GetAllStoresInHistory')
    }

    countHubspotTicket(pipelineId): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/CountHubspotTicket?pipelineId=' + pipelineId)
    }


    countProblemStores(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/countProblemStores')
    }

    countContentNgosPendingApproval(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/CountContentNgosPendingApproval')
    }

    getAdminMetrics(take): any {
        return this.http.get(Configuration.apiUrl + 'Api/Metrics/AdminMetrics?take=' + take)
    }

    getAdminFinanceInfo(full: boolean, month, year): any {
        console.log(Configuration.apiUrl + `Api/Finance/FinanceControl?full=${full}&month=${month}&year=${year}`)
        return this.http.get(Configuration.apiUrl + `Api/Finance/FinanceControl?full=${full}&month=${month}&year=${year}`)
    }

    getAdminMonthlyFinanceControl(month, year): any {
        console.log(Configuration.apiUrl + `Api/Finance/MonthlyFinanceControl?month=${month}&year=${year}`)
        return this.http.get(Configuration.apiUrl + `Api/Finance/MonthlyFinanceControl?month=${month}&year=${year}`)
    }

    getAdminStatement(id): any {
        return this.http.get(Configuration.apiUrl + 'Api/Statement/AdminStatement?id=' + id)
    }

    createManualStatement(manual): any {
        console.log(JSON.stringify(manual))
        return this.http.post(Configuration.apiUrl + 'Api/Statement/AdminCreateManualStatement', JSON.stringify(manual), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updateStatementInvoice(statement): any {
        console.log(JSON.stringify(statement))
        return this.http.post(Configuration.apiUrl + 'Api/Finance/AdminUpdateStatementInvoice', JSON.stringify(statement), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminUpdateNotaFiscal(statement): any {
        return this.http.post(Configuration.apiUrl + 'Api/Finance/adminUpdateNotaFiscal', JSON.stringify(statement), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminUpdateDonationFromStatement(statementId, donationId, value, description): any {
        return this.http.post(Configuration.apiUrl + 'Api/Finance/AdminUpdateDonationFromStatement?statementId='
            + statementId
            + '&donationId=' + donationId
            + '&value=' + value
            + '&description=' + description
            , null, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updatePolenSubscription(statement): any {
        return this.http.post(Configuration.apiUrl + 'Api/Finance/adminUpdatePolenSubscription', JSON.stringify(statement), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updatePolenSubItens(statement: StoreStatement): any {
        console.log(statement.subItens);
        console.log('Api/Finance/adminupdatePolenSubItens?statementId=' + statement.id);
        return this.http.post(Configuration.apiUrl + 'Api/Finance/adminupdatePolenSubItens?statementId=' + statement.id, JSON.stringify(statement.subItens), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updatePlan(statement): any {
        return this.http.post(Configuration.apiUrl + 'Api/Finance/adminUpdatePlan', JSON.stringify(statement), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updatePaymentList(statement): any {
        return this.http.post(Configuration.apiUrl + 'Api/Finance/adminUpdatePaymentList', JSON.stringify(statement), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    //atualiza o .Date que é a data que foi criada a fatura
    updateStatementDate(statement): any {
        return this.http.post(Configuration.apiUrl + 'Api/Finance/adminUpdateStatementDate', JSON.stringify(statement), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    //atualiza o InvoiceDate que eh a data de expiracao da fatura
    updateStatementInvoiceDate(statement): any {
        return this.http.post(Configuration.apiUrl + 'Api/Finance/adminUpdateStatementInvoiceDate', JSON.stringify(statement), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    createInvoiceStatement(statementId, invoiceType, chargeCreditCard): any {
        console.log(Configuration.apiUrl + 'Api/Statement/AdminCreateInvoice?statementId=' + statementId + '&invoiceType=' + invoiceType + '&chargeCreditCard=' + chargeCreditCard);
        return this.http.get(Configuration.apiUrl + 'Api/Statement/AdminCreateInvoice?statementId=' + statementId + '&invoiceType=' + invoiceType + '&chargeCreditCard=' + chargeCreditCard)
    }

    create2viaInvoiceStatement(statementId, invoiceType): any {
        console.log(Configuration.apiUrl + 'Api/Statement/AdminCreateSecondViaInvoice?statementId=' + statementId + '&invoiceType=' + invoiceType);
        return this.http.get(Configuration.apiUrl + 'Api/Statement/AdminCreateSecondViaInvoice?statementId=' + statementId + '&invoiceType=' + invoiceType)
    }

    deleteStatement(statementId): any {
        return this.http.get(Configuration.apiUrl + 'Api/statement/AdminDeleteStatement?statementId=' + statementId)
    }

    deleteUserStatement(statementId): any {
        //console.log(Configuration.apiUrl + 'Api/statement/AdminDeleteUserStatement?statementId=' + statementId)
        return this.http.get(Configuration.apiUrl + 'Api/statement/AdminDeleteUserStatement?statementId=' + statementId)
    }

    createNfeIoInvoiceByStatementId(storeUrl, statementId): any {
        console.log(Configuration.apiUrl + 'Api/Finance/CreateNfeIoInvoiceByStatementId?storeUrl=' + storeUrl + '&statementId=' + statementId)
        return this.http.get(Configuration.apiUrl + 'Api/Finance/CreateNfeIoInvoiceByStatementId?storeUrl=' + storeUrl + '&statementId=' + statementId)
        //return this.http.get('http://localhost:49784/Api/Finance/CreateInvoiceNfeio?storeUrl=' + storeUrl + '&iuguInvoiceId='+ iuguInvoiceId)
    }

    adminFixTotalPrice(orderId): any {
        return this.http.get(Configuration.apiUrl + 'Api/FixError/FixTotalPrice?orderId=' + orderId)
    }

    updateStatusStore(store): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Dashboard/adminUpdateStatusStore', JSON.stringify(store), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updateCategory(store): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Dashboard/AdminUpdateCategory', JSON.stringify(store), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminUpdateLastPaidDate(store): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Dashboard/AdminUpdateLastPaidDate', JSON.stringify(store), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminUpdateMrr(seoUrl): any {
        debugger
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/AdminUpdateMrr?storeName=' + seoUrl);
    }

    updateCountLastMonthSales(seoUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/updateCountLastMonthSales?storeName=' + seoUrl)
    }

    sendEmailStartTrial(storeName): any {
        return this.http.get(Configuration.apiUrl + 'Api/Dashboard/sendEmailStartTrial?storeName=' + storeName)
    }
}
